export enum Lang {
  en = 'english',
  ar = 'arabic',
}
